import { Attachment } from "@rms-types/modules/attachment/entities/attachment";
import { useSnackbar } from "notistack";

import { attachmentEndpoint } from "@/constants";
import { getErrorMessage } from "@/helpers";
import { UseDeleteOptions, useDelete } from "@/hooks";

export function useDeleteAttachment(options: UseDeleteOptions<Attachment> = {}) {
  const endpoint = attachmentEndpoint.attachment;
  const { enqueueSnackbar } = useSnackbar();

  const {
    mutate: deleteAttachment,
    error: deleteAttachmentError,
    isPending: isDeleteAttachmentPending,
    ...rest
  } = useDelete({
    endpoint,
    options: {
      ...options,
      onError: (error, variables, context) => {
        options.onError && options.onError(error, variables, context);
        enqueueSnackbar(getErrorMessage(error, "Failed to delete the folder"), { variant: "error" });
      },
    },
  });

  return {
    deleteAttachment,
    isDeleteAttachmentPending,
    deleteAttachmentError,
    ...rest,
  };
}
